enum NoteStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export default NoteStatusEnum
